import React from 'react';

import PropTypes from 'prop-types';

const QuoterStepList = ({ totalSteps, currentStep }) => {
  const quoterStepList = [];

  for (let i = 1; i <= totalSteps; i += 1) {
    let stepClasses = 'step';
    if (i === currentStep) {
      stepClasses += ' -current';
    } else if (i < currentStep) {
      stepClasses += ' -previous';
    }

    quoterStepList.push((
      <div className={stepClasses} key={`step-number-${i}`}>
        <div className="checkmark" />
        <div className="number">{i}</div>
      </div>
    ));
  }
  return (
    <>
      <div className="progress-line" />
      <div className="steps">
        {quoterStepList}
      </div>
    </>
  );
};

QuoterStepList.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default QuoterStepList;
